import type { Entity } from 'src/lib/collection';

export interface BrandVoice extends Entity {
  name: string;
}

export type BrandVoiceRef = Pick<BrandVoice, 'id'>;

export const BRAND_VOICE_ASSET = {
  customModel: 'customModel',
  targetAudience: 'targetAudience',
  toneOfVoice: 'toneOfVoice',
  brandRule: 'brandRule',
  messagingBank: 'messagingBank',
} as const;
export type BrandVoiceAsset = (typeof BRAND_VOICE_ASSET)[keyof typeof BRAND_VOICE_ASSET];

export const BRAND_VOICE_ASSET_FIELD = {
  toneOfVoices: 'toneOfVoices',
  customModels: 'customModels',
  customFormats: 'customFormats',
  customFormatGroups: 'customFormatGroups',
  targetAudiences: 'targetAudiences',
  brandBriefs: 'brandBriefs',
  brandTerms: 'brandTerms',
} as const;
export type BrandVoiceAssetField =
  (typeof BRAND_VOICE_ASSET_FIELD)[keyof typeof BRAND_VOICE_ASSET_FIELD];

export const formatBrandVoicesNames = (brandVoices: BrandVoice[]) => {
  if (!Array.isArray(brandVoices) || brandVoices.length === 0) {
    return ''; // Return an empty string if the input is not a valid array or is empty
  }

  if (brandVoices.length === 1) {
    return `‘${brandVoices[0].name}’`; // If only one brand name, return it wrapped in single quotes
  }

  const allButLast = brandVoices
    .slice(0, -1)
    .map((voice) => `‘${voice.name}’`)
    .join(', ');
  const last = `‘${brandVoices[brandVoices.length - 1].name}’`;

  return `${allButLast} & ${last}`;
};

export const formatTopThreeBrandVoicesWithCount = (brandVoices: BrandVoice[]) => {
  if (!Array.isArray(brandVoices) || brandVoices.length === 0) {
    return ''; // Return an empty string if the input is not a valid array or is empty
  }

  const firstThreeNames = brandVoices
    .slice(0, 3)
    .map((voice) => voice.name)
    .join(', ');
  const remainingCount = brandVoices.length - 3;

  return remainingCount > 0 ? `${firstThreeNames} +${remainingCount}` : firstThreeNames;
};
